import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _ from 'lodash';
import React, { Fragment } from 'react';
import { graph } from '@adc/constants';
import { G } from '@adc/sdk';
import Modal from '../../../overlays/modal';
import Text from '../../../elementals/text';
import { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base';
import FullWidthBadge from './fullWidthBadge';
import { getAssetType, isREO } from './utils';
const occupancyStatus = listing => _.get(listing, 'listing_configuration.occupancy_status', '');
class PropertyOccupiedBadge extends FullWidthBadge {
    static title = 'Occupancy';
    static titleIcon = 'users';
    static textIcon = 'times';
    static summary = 'Occupied';
    static renderPriority = BADGE_ORDER_PRIORITY.SECOND;
    static contentPositive = false;
    static shouldBeHoisted = true;
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            occupancyStatus(listing) === graph.enums.OccupancyStatus.OCCUPIED);
    }
    get content() {
        const zip = _.get(this.props.listing, 'primary_property.summary.address.postal_code', null);
        const refLink = zip
            ? `/residential/${zip}_zp/active_lt/vacant_os/`
            : `/residential/active_lt/vacant_os/`;
        const refMessage = zip
            ? 'No thanks, show me vacant properties in this area'
            : 'No thanks, show me vacant properties';
        const headerText = getAssetType(this.props.listing) === G.AssetType.BankOwned
            ? 'This property may be occupied and the buyer will be responsible for obtaining possession after closing.  Do not disturb occupants or trespass.'
            : 'Do not disturb occupants. Trespassing is a criminal offense.';
        return (_jsxs(_Fragment, { children: [headerText, ' ', _jsx(Modal, { title: 'Why bid on occupied properties?', size: 'tiny', mobileTitleSkin: 'light', fullScreen: 'mobileOnly', elmId: 'occupancy_modal', trigger: _jsx("a", { "data-elm-id": 'occupancy_modal_trigger', children: "Learn more about occupied properties." }), children: _jsx(Modal.Content, { "data-elm-id": 'occupancy_modal_content', children: _jsxs(Text, { children: ["Although the idea of buying an occupied property may seem intimidating, some investors see opportunity because they can:", _jsxs("ul", { children: [_jsx("li", { children: "Buy the property before it hits the MLS" }), _jsx("li", { children: "Turn an occupant into a paying tenant" })] }), "Upon closing, you are responsible for any evictions. If you've never done this, be sure to research your local laws.", _jsxs("ul", { children: [_jsx("li", { children: _jsx("a", { href: '/blog/buying-an-occupied-property/', target: '_blank', children: "Learn More" }) }), _jsx("li", { children: _jsx("a", { href: refLink, target: '_blank', rel: 'noreferrer', children: refMessage }) })] })] }) }) })] }));
    }
}
class PropertyUnknownOccupancyBadge extends PropertyOccupiedBadge {
    static summary = 'Occupancy Unknown';
    static shouldBeIncluded(listing, badgeMode) {
        const isUnknown = occupancyStatus(listing) === graph.enums.OccupancyStatus.UNKNOWN ||
            _.isNil(occupancyStatus(listing));
        return badgeMode === BADGE_MODE.EXPANDED && isUnknown;
    }
}
class PropertyVacantBadge extends PropertyOccupiedBadge {
    static title = 'Occupancy';
    static titleIcon = 'users';
    static textIcon = 'check';
    static summary = 'Vacant';
    static condensedTitle = 'Vacant';
    static condensedTitleIcon = 'sign';
    static renderPriority = BADGE_ORDER_PRIORITY.SECOND;
    static contentPositive = true;
    static shouldBeHoisted = true;
    static shouldBeIncluded(listing) {
        return occupancyStatus(listing) === graph.enums.OccupancyStatus.VACANT;
    }
    get content() {
        return isREO(this.props.listing)
            ? 'Although the property is vacant, do not enter unless interior access is available.'
            : 'Although the property is believed to be vacant, do not enter premises. Trespassing is a crime.';
    }
}
export { PropertyOccupiedBadge, PropertyVacantBadge, PropertyUnknownOccupancyBadge, };
//# sourceMappingURL=occupancy.js.map